import React, { useContext, useState } from "react";
import APIContext from "../../hooks/API";
import { LoginContext } from "../Login";
import { Saved } from ".";
import { T } from "../traks";

const UserForm = () => {
	const { user } = useContext(LoginContext);
	const { put } = useContext(APIContext);
	let details = user?.details;
	const [firstname, setFirstname] = useState(details?.firstname);
	const [lastname, setLastname] = useState(details?.lastname);
	const [homephonenumber, setHomephonenumber] = useState(
		details?.homephonenumber
	);
	const [workphonenumber, setWorkphonenumber] = useState(
		details?.workphonenumber
	);
	const [street, setStreet] = useState(details?.street);
	const [city, setCity] = useState(details?.city);
	const [zip, setZip] = useState(details?.zip);
	const [state, setState] = useState(details?.state);
	const [country, setCountry] = useState(details?.country);
	const [madeChanges, setMadeChanges] = useState(false);
	const [saved, setSaved] = useState(false);

	const setValue = (val, func) => {
		setMadeChanges(true);
		setSaved(false);
		func(val);
	};

	const cancel = () => {
		setMadeChanges(false);
		setFirstname(details.firstname);
		setLastname(details.lastname);
		setHomephonenumber(details.homephonenumber);
		setWorkphonenumber(details.workphonenumber);
		setStreet(details.street);
		setCity(details.city);
		setZip(details.zip);
		setState(details.state);
		setCountry(details.country);
		setSaved(false);
	};

	const save = (e) => {
		e.preventDefault();
		setMadeChanges(false);
		let args = {
			firstname,
			lastname,
			homephonenumber,
			workphonenumber,
			street,
			city,
			zip,
			state,
			country,
		};
		put({
			path: `/user/${user.agentId}`,
			args,
		}).then((e) => {
			user.details = args;
			setSaved(true);
		});
	};

	return (
		<div className="app-card">
			<div className="app-card-header">
				<T>User info</T>
			</div>
			<div className="app-card-body">
				<form autoComplete="on" onSubmit={save}>
					<div className="form-row">
						<div>
							<label htmlFor="user-firstname" className="form-label">
								<T>First name</T>
							</label>
							<input
								id="user-firstname"
								name="given-name"
								type="text"
								autoComplete="given-name"
								placeholder="First name"
								className="form-control"
								value={firstname}
								onChange={(e) => setValue(e.target.value, setFirstname)}
							/>
						</div>
						<div>
							<label htmlFor="user-lastname" className="form-label">
								<T>Last name</T>
							</label>
							<input
								id="user-lastname"
								name="family-name"
								type="text"
								autoComplete="family-name"
								placeholder="Last name"
								className="form-control"
								value={lastname}
								onChange={(e) => setValue(e.target.value, setLastname)}
							/>
						</div>
					</div>
					<div className="form-row">
						<div>
							<label htmlFor="user-homephone" className="form-label">
								<T>Home phone</T>
							</label>
							<input
								id="user-homephone"
								name="home-phone"
								type="tel"
								autoComplete="tel"
								placeholder="Home phone"
								className="form-control"
								value={homephonenumber}
								onChange={(e) => setValue(e.target.value, setHomephonenumber)}
							/>
						</div>
						<div>
							<label htmlFor="user-workphone" className="form-label">
								<T>Work phone</T>
							</label>
							<input
								id="user-workphone"
								name="work-phone"
								type="tel"
								autoComplete="tel"
								placeholder="Work phone"
								className="form-control"
								value={workphonenumber}
								onChange={(e) => setValue(e.target.value, setWorkphonenumber)}
							/>
						</div>
					</div>
					<div className="mb-3">
						<label htmlFor="user-street" className="form-label">
							<T>Address</T>
						</label>
						<input
							id="user-street"
							name="street-address"
							type="text"
							autoComplete="street-address"
							placeholder="Street address"
							className="form-control"
							value={street}
							onChange={(e) => setValue(e.target.value, setStreet)}
						/>
					</div>
					<div className="form-row">
						<div>
							<label htmlFor="user-zip" className="form-label">
								<T>Zip code</T>
							</label>
							<input
								id="user-zip"
								name="postal-code"
								type="text"
								autoComplete="postal-code"
								placeholder="Zip"
								className="form-control"
								value={zip}
								onChange={(e) => setValue(e.target.value, setZip)}
							/>
						</div>
						<div>
							<label htmlFor="user-city" className="form-label">
								<T>City</T>
							</label>
							<input
								id="user-city"
								name="address-level2"
								type="text"
								autoComplete="address-level2"
								placeholder="City"
								className="form-control"
								value={city}
								onChange={(e) => setValue(e.target.value, setCity)}
							/>
						</div>
					</div>
					<div className="form-row">
						<div>
							<label htmlFor="user-state" className="form-label">
								<T>State</T>
							</label>
							<input
								id="user-state"
								name="address-level1"
								type="text"
								autoComplete="address-level1"
								placeholder="State"
								className="form-control"
								value={state}
								onChange={(e) => setValue(e.target.value, setState)}
							/>
						</div>
						<div>
							<label htmlFor="user-country" className="form-label">
								<T>Country</T>
							</label>
							<input
								id="user-country"
								name="country-name"
								type="text"
								autoComplete="country-name"
								placeholder="Country"
								className="form-control"
								value={country}
								onChange={(e) => setValue(e.target.value, setCountry)}
							/>
						</div>
					</div>
					<div className="d-flex justify-content-end gap-2 mt-3">
						<button
							disabled={!madeChanges}
							className="btn-cancel"
							type="button"
							onClick={cancel}
						>
							<T>Cancel</T>
						</button>
						<button
							disabled={!madeChanges}
							type="submit"
							className="btn-save"
						>
							<Saved isSaved={saved} />
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default UserForm;
